module.exports = __webpack_public_path__ + "img/logo.5ed49352.svg";